module.exports = __webpack_public_path__ + "img/Cheriyan.John.73404141.jpg";